import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ArrowSecondary from './ArrowSecondary'
import styles from './dropdown.scss'

class Dropdown extends React.Component {
  constructor(props) {
    super(props)

    this.handleDropdown = this.handleDropdown.bind(this)
  }

  state = {
    // eslint-disable-line react/state-in-constructor
    open: false
  }

  handleDropdown() {
    const { open } = this.state

    this.setState({ open: !open })
  }

  render() {
    const { label, padding, children } = this.props

    const { open } = this.state

    const dropdownClass = classNames(styles.dropdown, {
      [styles.open]: open,
      [styles.padding]: padding
    })

    const header = (
      <div className={styles.header}>
        <div
          className={styles.label}
          onClick={this.handleDropdown}
          onKeyDown={this.handleDropdown}
          role="button"
          tabIndex="0"
        >
          {label}

          <ArrowSecondary width="8px" height="8px" />
        </div>
      </div>
    )

    return (
      <div className={dropdownClass}>
        {header}

        <div // eslint-disable-line
          className={styles.content}
          onClick={this.handleDropdown}
        >
          {children}
        </div>
      </div>
    )
  }
}

Dropdown.defaultProps = {
  label: null,
  padding: false,
  children: null
}

const { bool, element, node, string, oneOfType } = PropTypes

Dropdown.propTypes = {
  label: oneOfType([element, node, string]),
  padding: bool,
  children: oneOfType([element, node, string])
}

export default Dropdown
